import { render, staticRenderFns } from "./tab5.vue?vue&type=template&id=0e006a0c&scoped=true"
import script from "./tab5.vue?vue&type=script&lang=js"
export * from "./tab5.vue?vue&type=script&lang=js"
import style0 from "./tab5.vue?vue&type=style&index=0&id=0e006a0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e006a0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e006a0c')) {
      api.createRecord('0e006a0c', component.options)
    } else {
      api.reload('0e006a0c', component.options)
    }
    module.hot.accept("./tab5.vue?vue&type=template&id=0e006a0c&scoped=true", function () {
      api.rerender('0e006a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab5.vue"
export default component.exports